/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(files(key).name, files(key)))

import wysiwyg from 'vue-wysiwyg';

Vue.use(wysiwyg, {});

/**
 * Inputs
 */
import IfpInput from "./components/Inputs/IfpInput";

Vue.component(IfpInput.name, IfpInput);

import IfpInputText from "./components/Inputs/IfpInputText";

Vue.component(IfpInputText.name, IfpInputText);

import IfpInputColor from "./components/Inputs/IfpInputColor";

Vue.component(IfpInputColor.name, IfpInputColor);

import IfpTextarea from "./components/Inputs/IfpTextarea";

Vue.component(IfpTextarea.name, IfpTextarea);

import IfpWysiwyg from "./components/Inputs/IfpWysiwyg";

Vue.component(IfpWysiwyg.name, IfpWysiwyg);

/**
 * Utilities
 */
import Modal from './components/Utilities/Modal';

Vue.component(Modal.name, Modal);

import Pagination from "./components/Utilities/Pagination";

Vue.component(Pagination.name, Pagination);

import EditableLink from "./components/Utilities/EditableLink";

Vue.component(EditableLink.name, EditableLink);

/**
 * Notifications
 */
import NotificationMoreInfoModal from "./components/Notifications/NotificationMoreInfoModal";

Vue.component(NotificationMoreInfoModal.name, NotificationMoreInfoModal);

import Notifications from "./components/Notifications/Notifications";

Vue.component(Notifications.name, Notifications);

import NotificationSnoozes from "./components/Notifications/NotificationSnoozes";

Vue.component(NotificationSnoozes.name, NotificationSnoozes);

/**
 * Microsites
 */
import Microsites from "./components/Microsites/Microsites";

Vue.component(Microsites.name, Microsites);

import MicrositeForm from "./components/Microsites/MicrositeForm";

Vue.component(MicrositeForm.name, MicrositeForm);

import MicrositeTemplates from "./components/Microsites/MicrositeTemplates";

Vue.component(MicrositeTemplates.name, MicrositeTemplates);


/** Filters */
Vue.filter('capitalize', function (value) {
    if (value === true) {
        value = 'true';
    } else if (value === false) {
        value = 'false';
    }

    if (!value) return '';

    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
});

import Toasted from 'vue-toasted';

Vue.use(Toasted, {duration: 3000, keepOnHover: true, iconPack: 'fontawesome'});

if (window.document.getElementById('app') !== null) {
    /**
     * Next, we will create a fresh Vue application instance and attach it to
     * the page. Then, you may begin adding components to this application
     * or customize the JavaScript scaffolding to fit your unique needs.
     */
    const app = new Vue({
        el: '#app',
    });

}